"use client";

import { Instagram, Facebook } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex justify-center gap-6">
        <div className="h-5 w-16 bg-muted/30 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted/30 animate-pulse rounded" />
        <div className="h-5 w-16 bg-muted/30 animate-pulse rounded" />
      </div>;
  }
  return <nav className="flex flex-wrap justify-center gap-6 mb-6">
      {menuItems.map((item, i) => <Link key={item.id} to={item.href || "#"} data-index={i} className="text-sm text-muted-foreground hover:text-accent transition-colors duration-[var(--duration-fast)]">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <footer id="pie-de-página" ref={ref} className={`dark-section py-16 px-4 transition-opacity duration-[var(--duration-medium)] ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="max-w-4xl mx-auto text-center">
        {}
        <div className="mb-8 flex justify-center">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1547753/img/marea_mezcal_logo.png" alt="Marea Mezcal" className="h-7" />
        </div>

        {}
        <MenuProvider menu_id="33" className="mb-8">
          <FooterMenuConsumer />
        </MenuProvider>

        {}
        <div className="flex justify-center gap-6 mb-8">
          <Link to="https://www.instagram.com/mareamezcal" newTab className="text-foreground-dark hover:text-accent hover:scale-110 hover:-translate-y-0.5 transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)]" aria-label="Instagram">
            <Instagram className="size-6" />
          </Link>
          <Link to="https://www.facebook.com/mareamezcal" newTab className="text-foreground-dark hover:text-accent hover:scale-110 hover:-translate-y-0.5 transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)]" aria-label="Facebook">
            <Facebook className="size-6" />
          </Link>
        </div>

        {}
        <p className="text-sm text-muted-foreground">
          &copy; {new Date().getFullYear()} Marea Mezcal – Cocina Mexicana Contemporánea. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}